<template>
  <div>
    <v-expansion-panels
      style="display: none"
      class="mb-4"
    >
      <v-expansion-panel>
        <v-expansion-panel-header>
          Фильтры
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card class="elevation-0">
            <WBDOfferListPageFilter
              :hide-office="office"
              :offer-list-filter-set="offerListFilter"
            />
            <v-card-actions>
              <v-spacer />
              <v-btn
                v-if="getActiveFilterNumber > 0"
                class="mr-1"
                text
                color="warning"
                @click="resetFilterSet"
              >
                {{ `Очистить` }}
              </v-btn>
              <v-btn
                color="success"
                dark
                class="mb-2"
                @click="load(1, options.itemsPerPage)"
              >
                Применить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-card-actions v-if="!loading">
      <v-spacer />
      <v-btn
        text
        color="warning"
      >
        <span> {{ searchResultLabel }} </span>
      </v-btn>
    </v-card-actions>
    <div v-if="!$route.query.sourceFile">
      <ListFilter
        :hide-office-list="office"
        :date-from.sync="filters.dateFrom"
        :date-to.sync="filters.dateTo"
        :set-end-date="setEndDate"
        :set-start-date="setStartDate"
        :model-number.sync="filters.modelNumber"
        :office-list.sync="filters.officeList"
        lite
        date-to-label="Начала До"
        date-from-label="Начала С"
      />
      <div
        class="my-2 text-right"
      >
        <v-btn
          :color="'warning'"
          rounded
          text
          class="mx-2"
          @click="clearFilter"
        >
          очистить
        </v-btn>
        <v-btn
          :color="'success'"
          rounded
          class="mx-2"
          @click="load"
        >
          Обновить
        </v-btn>
      </div>
    </div>
    <v-alert
      v-else
      type="warning"
      prominent
    >
      <v-row align="center">
        <v-col
          cols="12"
          class="grow"
        >
          Вы смотрите список оффров по одному файлу. Чтобы увидеть все офферы нажмите на кнопку
        </v-col>
        <v-col
          cols="12"
          class="shrink"
        >
          <v-btn @click="removeFilter">
            К Списку
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <v-data-table
      fixed-header
      :height="tableHeight"
      :items="offerList"
      :headers="headers"
      :loading="loading"
      expand-icon="visibility"
      singleExpand
      flat
      multi-sort
      :expanded.sync="expandedList"
      show-expand
      :options.sync="options"
      :server-items-length="getPaginator"
      :footer-props="footerProps"
      @item-expanded="onOfferClick"
    >
      <template v-slot:item.startAt="{ item }">
        {{ `${item.startDate} ${item.startTime} ${item.localeStartTime ? ` Мест. (${item.localeStartTime})` : ''}` }}
      </template>
      <template v-slot:item.isPrivate="{ item }">
        {{ `${item.isPrivate? `ДА` : 'Нет'}` }}
      </template>
      <template v-slot:item.supportNumber="{ item }">
        <SupportNumberLink
          v-if="item.status !== 'draft'"
          :model="item"
          :route-name="offerViewRouteName"
        />
        <span v-else>{{ item.supportNumber }}</span>
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ `${item.createdDate} ${item.createdTime}` }}
      </template>
      <template v-slot:item.status="{ item }">
        {{ `${getStatus(item.status, item.scheduler.canceled)}` }}
      </template>
      <template v-slot:item.vacancy="{ item }">
        <span style="display: block">{{ `${item.vacancy.title}` }}</span>
        <span style="color: grey">{{ `${item.vacancy.externalTitle}` }}</span>
      </template>
      <template v-slot:item.endAt="{ item }">
        {{ `${item.endDate} ${item.endTime} ${item.localeEndTime ? ` Мест. (${item.localeEndTime})` : ''}` }}
      </template>
      <template v-slot:item.respondList="{ item }">
        {{ item.respondList.length }}
      </template>
      <template v-slot:item.invitationList="{ item }">
        {{ item.invitationList.length }}
      </template>
      <template v-slot:item.office="{ item }">
        <OfficeListItemComponent :office="item.office" />
      </template>
      <template v-slot:item.relayList="{ item }">
        {{ item.relayList.length }}
      </template>
      <template v-slot:item.executor="{ item }">
        <span v-if="item.executor">
          <span style="display: block"> {{ item.executor.fullName }}</span>
          <a
            style="display: block; margin: 0"
            :href="`tel:${item.executor.username}`"
          > {{ item.executor.username }}</a>
          <v-btn
            v-if="item.executor.isSelfEmployed"
            class="px-0"
            color="success"
            rounded
            x-small
          >
            самозанятый
          </v-btn>
        </span>
      </template>
      <template
        v-slot:item.author="{ item }"
      >
        <v-list-item class="px-2">
          <v-list-item-title>
            <span style="display: block"> {{ item.author.fullName }}</span>
            <a
              style="display: block; margin: 0 0 3px;"
              :href="`mailto:${item.author.email}`"
            > {{ item.author.email }}</a>
            <a
              style="display: block; margin: 0"
              :href="`tel:${item.author.telephone}`"
            > {{ item.author.telephone }}</a>
          </v-list-item-title>
        </v-list-item>
      </template>
      <template
        v-slot:expanded-item="{ headers, item }"
      >
        <td
          v-if="!isDraft(item)"
          :colspan="headers.length"
          class="py-6"
        >
          <template>
            <v-data-table
              v-if="offer && offer.id"
              fixed-header
              :height="tableHeight"
              style="background: #a9a9a93d"
              :headers="respondHeaderList"
              :loading="offerLoading"
              :items="getChildrenView"
              hide-default-footer
              class="elevation-1"
            >
              <template v-slot:item.createdAt="{ item }">
                {{ formatDate(item.createdAt) }}
              </template>
              <template v-slot:item.startedAt="{ item }">
                {{ item.type === 'Смена' ? formatDate(item.startedAt) : formatDate(offer.startAt) }}
              </template>
              <template v-slot:item.endAt="{ item }">
                {{ item.type === 'Смена' ? formatDate(item.endAt) : formatDate(offer.endAt) }}
              </template>
              <template
                v-slot:item.laborer="{ item }"
              >
                <v-list-item class="px-2">
                  <v-list-item-avatar v-if="item.laborer.avatar && item.laborer.avatar.path">
                    <v-img :src="item.laborer.avatar.path" />
                  </v-list-item-avatar>
                  <v-list-item-title>
                    <span style="display: block"> {{ item.laborer.fullName }}</span>
                    <span style="display: block; color: dimgrey"> {{ item.laborer.phone }}</span>
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-data-table>
          </template>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ListMixin from '@/mixins/list-mixin.vue'
import OfferViewMixin from '@/mixins/offerViewMixin'
import ListFilter from '@/components/common/filter/list-filter.vue'
import RelayView from '@/mixins/relay-mixin.vue'
import OfficeListItemComponent from '@/components/common/listItem/officeListItem'
import SupportNumberLink from '@/components/common/listItem/supportNumberLink'
import QueryFilterMixin from '@/mixins/RouterDataMixin'
import WBDOfferListPageFilter from '@/components/common/filter/offer-list-page-filter'

import {
  // mapOffer,
  mapOfferList
} from '@/utils/offerUtil'
import { CLIENT_OFFER_VIEW_ROUTE_NAME } from '@/router/client'
import ListSortUtil from '@/utils/list-sort-util'
import { pluriaizeRows } from '@/utils/plural-util'

export default {
  name: 'WBDOfferListPage',
  components: {
    ListFilter,
    OfficeListItemComponent,
    WBDOfferListPageFilter,
    SupportNumberLink
  },
  mixins: [ListMixin, RelayView, OfferViewMixin, QueryFilterMixin],
  props: {
    office: {
      type: Object
    },
  },
  data: () => ({
    offerListFilter: {
      dateFrom: null,
      dateTo: null,
      office: null,
      published: null,
      type: null,
      searchQuery: null,
    },
    getPaginator: undefined,
    filters: {
      dateFrom: null,
      dateTo: null,
      modelNumber: null,
      officeList: [],
    },
    options: {},
    loading: true,
    offerViewRouteName: CLIENT_OFFER_VIEW_ROUTE_NAME,
    offerLoading: false,
    offer: null,
    currentRowData: null,
    offerList: [],
    respondHeaderList: [
      {
        text: 'Создано',
        align: 'left',
        sortable: false,
        value: 'createdAt',
      },
      {
        text: 'Статус',
        align: 'left',
        sortable: false,
        value: 'status',
      },
      { text: 'Тип', value: 'type' },
      { text: 'Начало Смены', value: 'startedAt' },
      { text: 'Конец Смены', value: 'endAt' },
      { text: 'ЗП', value: 'pay' },
      { text: 'исполнитель', value: 'laborer' },
      { text: '', value: 'options' },
    ],
    userHeaders: [
      { text: 'Создан', value: 'createdAt' },
      {
        text: 'ФИО',
        align: 'left',
        sortable: false,
        value: 'fullName',
      },
      { text: 'Телефон', value: 'telephone' },
      { text: 'Активирован', value: 'isActive' },
      { text: 'Почта', value: 'username' },
    ],
    expandedList: ['dc3911ca-2dda-4f33-b9a4-f98f0a0bd4b5'],
    headers: [
      {
        text: 'Номер',
        align: 'left',
        sortable: false,
        value: 'supportNumber',
      },
      {
        text: 'Задание',
        align: 'left',
        sortable: false,
        value: 'externalTaskId',
      },
      {
        text: 'Исполнитель',
        align: 'left',
        sortable: false,
        value: 'executor',
      },
      {
        text: 'Смены для своих',
        align: 'left',
        sortable: false,
        value: 'isPrivate',
      },
      {
        text: 'Видимость',
        align: 'left',
        sortable: false,
        value: 'accessLevel',
      },
      { text: 'наз. исполнителя', value: 'executorAssignmentType.label', sortable: false },
      {
        text: 'Объект',
        align: 'left',
        sortable: false,
        value: 'office',
      },
      {
        text: 'Адрес объекта',
        align: 'left',
        sortable: false,
        value: 'office.location.address',
      },
      {
        text: 'Вакансия',
        align: 'left',
        sortable: false,
        value: 'vacancy',
      },
      {
        text: 'Статус',
        align: 'left',
        sortable: false,
        value: 'status',
      },
      { text: 'Создан', value: 'createdAt', sortable: false },
      {
        text: 'Начало',
        align: 'left',
        sortable: true,
        value: 'startAt',
      },
      { text: 'Конец', value: 'endAt', sortable: true },
      { text: 'Длительность', value: 'duration', sortable: false },
      { text: 'Перерыв', value: 'break.duration', sortable: false },
      { text: 'Создатель', value: 'author', sortable: false },
      { text: 'Работников', value: 'childrenNumber', sortable: false },
      { text: 'Отклики', value: 'respondNumber', sortable: false },
      { text: 'приглашения', value: 'invitationNumber', sortable: false },
      { text: 'Смены', value: 'relayNumber', sortable: false },
      { text: 'Ставка', value: 'costPerHour', sortable: false },
      { text: 'ФОТ', value: 'expense', sortable: false },
      { text: 'ЗП', value: 'pay', sortable: false },
      { text: 'Просмотры', value: 'views', sortable: false },
      { text: 'Тип оффера', value: 'executorAssignmentType.label', sortable: false },
    ],
  }),
  computed: {
    getActiveFilterNumber () {
      const params = {
        ...this.offerListFilter
      }
      for (const [key, value] of Object.entries(params)) {
        if (!(value || (!value && (value === '0' || value === 0)))) {
          delete params[key]
        }
      }
      return Object.keys(params).length
    },
    searchResultLabel () {
      return `Найдено: ${this.getPaginator} ${pluriaizeRows(this.getPaginator)}`
    },
    getChildrenView () {
      if (!this.offer) {
        return []
      }

      const laborerList = {}
      for (const respond of this.offer.respondList) {
        if (respond && respond.laborer) {
          laborerList[respond.laborer.id] = respond.laborer
        }
      }
      return [
        ...this.offer.relayList.map((item) => ({ ...item, type: 'Смена' })),
        ...this.offer.invitationList.map((item) => (
          { ...item, type: 'Приглашение' })
        ),
        ...this.offer.respondList.map((item) => ({ ...item, type: 'Отклик' })),
      ]
    },
  },
  watch: {
    options: {
      handler () {
        this.load()
      },
      deep: true,
    },
  },
  created () {
    const querySupportNumber = this.$route.query.supportNumber

    if (querySupportNumber) {
      this.filters.modelNumber = querySupportNumber
      this.$forceUpdate()
    }
    this.options = {
      page: 1,
      itemsPerPage: this.footerProps.itemsPerPageOptions[0],
    }
    this.$moment.locale('ru')
    this.$moment.lang('ru')
    this.queryStatus = this.$route.query.status || 'new'
    this.$moment.locale('ru')
    this.$moment.lang('ru')
    const startDate = this.$moment()
    const endDate = this.$moment()
    this.filters.dateFrom = endDate.format('YYYY-MM-DD')
    this.filters.dateTo = startDate.format('YYYY-MM-DD')
  },
  methods: {
    clearFilter () {
      this.filters = {
        dateFrom: null,
        dateTo: null,
        modelNumber: null,
        officeList: [],
      }

      this.eventsBus.$emit(this.eventNames.DEFAULT_LIST_FILTER_RESET)
    },
    async load () {
      let payload = {
        // page: 1,
        // size: 200
      }
      if (this.$route.query.sourceFile) {
        payload = {
          'media[id]': this.$route.query.sourceFile,
        }
      } else if (this.filters) {
        if (this.filters.modelNumber) {
          payload = {
            'supportNumber': parseInt(this.filters.modelNumber, 10),
          }
        } else {
          if (this.office) {
            this.filters.officeList = [this.office]
          }
          if (this.filters.officeList.length) {
            for (const [index, office] of this.filters.officeList.entries()) {
              payload[`officeList[${index}][id]`] = office.id
            }
          }
          if (this.filters.dateFrom) {
            payload.createFrom = this.filters.dateFrom
          }
          if (this.filters.dateTo) {
            payload.createTo = this.filters.dateTo
          }
        }
      }

      await this.requestList(payload)
    },
    async requestList (payload = {}) {
      const sortData = ListSortUtil.getSortData(this.options)
      this.offerList = []

      try {
        const paginationData = { 'page[number]': this.options.page, 'page[size]': this.options.itemsPerPage }
        this.loading = true
        const list = await this.$store.dispatch(
          'organization/getOffersList',
          {
            params: { ...payload, ...paginationData, ...sortData }
          }
        )

        if (list && list.headers) {
          this.getPaginator = parseInt(`${list.headers['x-total-count']}`, 10)
        } else {
          this.getPaginator = undefined
        }

        this.loading = false

        this.offerList = mapOfferList(list.data).map((item) => {
          return {
            ...item,
            accessLevel: item.executorGroupType.label
          }
        })
      } catch (error) {
        this.loading = false
      }
    },
    gotoPersonalData (item) {
      this.gotoLaborerPersonalData(item.laborer.id)
    },
    isPlaned (item) {
      return item.status === 'planed'
    },
    async resetFilterSet () {
      const hasFilter = this.getActiveFilterNumber
      this.offerListFilter = {
        dateFrom: null,
        dateTo: null,
        office: null,
        published: null,
        type: null,
        searchQuery: null,
      }

      this.eventsBus.$emit(this.eventNames.OFFER_LIST_PAGE_FILTER_RESET)

      if (hasFilter > 0) {
        await this.load(1, this.options.itemsPerPage)
      }
    },
    isDraft (item) {
      return item.status === 'draft'
    },
    async onOfferClick (rowData, status) {
      if (this.isDraft(rowData.item)) {
        return
      }

      let list = {
        relayList: [],
        invitationList: [],
        respondList: [],
      }
      this.currentRowData = rowData
      if (this.isPlaned(rowData.item)) {
        return
      }
      this.offer = rowData.item
      if (rowData.item && !!rowData.value) {
        this.offerLoading = true
        list = await this.$store.dispatch(
          'organization/getOfficeOffer',
          { groupToken: rowData.item.groupToken, id: rowData.item.id }
        )
        if (list.data && Array.isArray(list.data) && list.data.length) {
          delete list.data[0].id
          const offer = {
            ...rowData.item,
            ...list.data[0]
          }
          this.offer = offer
        }
        this.offerLoading = false
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.office-item {
  cursor: pointer;
}
.v-data-table-header th {
  white-space: nowrap;
}
</style>
